import { render } from "./CatalogSort.vue?vue&type=template&id=50ce229c&scoped=true"
import script from "./CatalogSort.vue?vue&type=script&lang=js"
export * from "./CatalogSort.vue?vue&type=script&lang=js"

import "./CatalogSort.vue?vue&type=style&index=0&id=50ce229c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50ce229c"]])

export default __exports__